import { isEmpty } from "./Constants";

export const HOURS = Array.from({ length: 24 }, (_, i) => i);

export const TODAY_FORMAT_DATE = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});

// ---------- date helpers ----------
export function addDays(date, n) { const d = new Date(date); d.setDate(d.getDate() + n); return d; }
export function startOfDay(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
export function startOfMonth(d) { const x = new Date(d); x.setDate(1); x.setHours(0, 0, 0, 0); return x; }
export function endOfMonth(d) { const x = new Date(d); x.setMonth(x.getMonth() + 1, 0); x.setHours(0, 0, 0, 0); return x; }
export function cmpDay(a, b) { return startOfDay(a).getTime() - startOfDay(b).getTime(); }

export function fmtKey(date) {
    if (date === null) {
        return "";
    }
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${d}/${m}/${y}`;
}
export function isPastDate(d) { return startOfDay(d) < startOfDay(new Date()); }
export function isSelectedDateIsPast(selectedDate, date) { return startOfDay(selectedDate) < startOfDay(date); }
export function datesBetween(a, b) {
    const s = startOfDay(a), e = startOfDay(b);
    const out = [];
    const step = s <= e ? 1 : -1;
    let cur = new Date(s);
    // inclusive range
    while ((step > 0 && cur <= e) || (step < 0 && cur >= e)) {
        out.push(new Date(cur));
        cur.setDate(cur.getDate() + step);
    }
    return out;
}

export function datesCount(a, b) {
    const s = startOfDay(a);
    const e = startOfDay(b);

    // Get the absolute difference in milliseconds
    const diffTime = Math.abs(e - s);

    // Convert milliseconds to days & add 1 for inclusive range
    return Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
}


export function getHoursDiff(time1, time2) {
    // Convert hh:mm:ss to total seconds
    const toSeconds = (time) => {
        const [h, m, s] = time.split(":").map(Number);
        return h * 3600 + m * 60 + s;
    };

    const diffSeconds = Math.abs(toSeconds(time2) - toSeconds(time1));

    // Convert seconds to hours (float)
    return diffSeconds / 3600;
}

export function getInclusiveHoursDiff(time1, time2) {
    // Convert hh:mm:ss → total seconds
    const toSeconds = (time) => {
        const [h, m, s] = time.split(":").map(Number);
        return h * 3600 + m * 60 + s;
    };

    const start = toSeconds(time1);
    const end = toSeconds(time2);

    // Calculate absolute difference in seconds
    const diffSeconds = Math.abs(end - start);

    // Convert to hours and make it inclusive
    return Math.floor(diffSeconds / 3600) + 1;
}

export function parseDateOnly(dateStr) {
    if (isEmpty(dateStr)) {
        return null;
    }
    const [day, month, year] = dateStr.split(" ")[0].split("/").map(Number);
    return new Date(year, month - 1, day); // month is 0-based in JS
}

export function getHourArray(startTime, endTime) {
    const out = [];
    if (!isEmpty(startTime) && !isEmpty(endTime)) {
        const [sh] = startTime.split(":").map(Number);
        const [eh] = endTime.split(":").map(Number);


        for (let h = sh; h <= eh; h++) {
            out.push(h);
        }
    }
    return out;
}

export function getMonthMatrix(viewDate) {
    const first = startOfMonth(viewDate);
    const last = endOfMonth(viewDate);
    const startIdx = (first.getDay() + 6) % 7; // Monday=0
    const daysInMonth = last.getDate();
    const days = [];
    for (let i = 0; i < startIdx; i++) days.push(addDays(first, i - startIdx));
    for (let i = 1; i <= daysInMonth; i++) { const d = new Date(first); d.setDate(i); days.push(d); }
    while (days.length % 7 !== 0) days.push(addDays(days[days.length - 1], 1));
    while (days.length < 42) days.push(addDays(days[days.length - 1], 1));
    return days;
}

// ---------- utils ----------
export function toArrayMap(mapLike) {
    const obj = {};
    if (!mapLike) return obj;
    for (const k of Object.keys(mapLike)) {
        const arr = Array.isArray(mapLike[k]) ? mapLike[k] : [];
        obj[k] = Array.from(new Set(arr)).sort((a, b) => a - b);
    }
    return obj;
}


export function toDate(dateStr) {
    const [day, month, year] = dateStr.split("/");
    const formattedDate = new Date(`${year}-${month}-${day}`);
    return formattedDate;
}


export const hourLabel = (h) =>
    `${String(h).padStart(2, "0")}:00 – ${String((h + 1) % 24).padStart(2, "0")}:00`;

export const toHour = (h) =>
    `${String(h).padStart(2, "0")}:00:00`;

export const getTime = () => {
    const today = new Date();
    return String(today.getHours()).padStart(2, "0") + ":" + String(today.getMinutes()).padStart(2, "0") + ":" + String(today.getSeconds()).padStart(2, "0");
}


export const hasTime = (dateStr) => {
    const regex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
    return regex.test(dateStr);
};

export const addTimeIfNot = (dateStr, defTime = "") => {
    if (isEmpty(dateStr)) {
        return "";
    }
    if (!isEmpty(defTime)) {
        return dateStr + " " + defTime;
    }
    return hasTime(dateStr) ? dateStr : (dateStr + " " + getTime());
}

export const ValidateNewBookingAllowed = (dateStr) => {
    const date = parseDateOnly(dateStr);
    const val = cmpDay(date, new Date());
    return !(val === 0 || val === 1);
}

export const addDaysStrDate = (dateStr, n) => {
    if (isEmpty(dateStr)) {
        return "";
    }
    const date = parseDateOnly(dateStr);
    const nDate = addDays(date, n);
    return fmtKey(nDate);
}

export const addDaysToTodayStrDate = (n) => {
    const nDate = addDays(new Date(), n);
    return fmtKey(nDate);
}

export function isSelectedDateStrIsPast(selectedDate, date) {
    const parseSelectedDate = parseDateOnly(selectedDate);
    const parseDate = parseDateOnly(date);
    return startOfDay(parseSelectedDate) < startOfDay(parseDate);
}